import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { Workspace } from 'features/workspaces/types'

type WorkspacesListSelector = (state: ReduxState) => Workspace[]
const getWorkspacesList: WorkspacesListSelector = state => Object.values(state.workspaces.workspaces)

export const workspacesListSelector: WorkspacesListSelector = createSelector(getWorkspacesList, list => list)
